import Modals from 'root/modals';
import View from 'view/base';

export default View.extend({
    className: 'system-notification',

    events: {
        'click .install-code' : 'onInstallCode',
        'click .account-upgrade' : 'onAccountUpgrade'
    },

    dom_handlers: {
        onInstallCode: function(e) {
            Modals.getWidgetCode();
        },

        onAccountUpgrade: function(e) {
            Modals.choosePlan();
        }
    },

    render: function() {
        var comment_data = JSON.parse(this.model.get('comment_data'));
        var content = '';

        if (comment_data.notification_body === 'onboarding1') {
            content =
            // TODO: complete the content
            '<h2>Welcome to Userback!</h2>' +
            '<button type="button" class="install-code primary medium">Install Code</button>';
        } else if (comment_data.notification_body === 'onboarding2') {
            // TODO: complete the content
            '<h2>Welcome to Userback!</h2>' +
            '<button type="button" class="account-upgrade primary medium">Upgrade</button>';
        } else if (comment_data.notification_body) {
            // generic html content (dangerous: html injection)
            content = comment_data.notification_body;
        }

        this.$el.html(content);

        return this;
    }
});